export default class newsManager {
    constructor(scroll,display){

        this.href = ''; //取得URL
        //取得データ
        this.pccategoryData;
        this.spcategoryData;
        this.listData;
        this.pagerData;

        this.status = {
            flg : false
        }

        this.scroll = scroll;
        this.display = display;

    }
    init() {

        //dom
        this.$categoryPC = $('.p-news-category.pc');
        this.$categorySP = $('#p-news-category-select');
        this.$list = $('.p-news-list');
        this.$pager = $('.p-news-pagination');

        this.$categoryPC.find('a').click((e) => {
            this.getAjax(e,'click');
            return false;
        });
        this.$categorySP.find('select').change((e) => {
            this.getAjax(e,'select');
            return false;
        });
        this.$pager.find('a').click((e) => {
            this.getAjax(e,'click');
            return false;
        });

    }
    getAjax(_target,_type){

        if(this.status.flg) return;
        this.status.flg = true;
        if(_type == 'click'){
            this.href = _target.target.href;
        }else{
            this.href = $(_target.target).val();
        }

        $.ajax({
            url: this.href,
            type: 'post',
            datatype:'html',
        }).done((data) => {
            //success
            let split_data = data.split('</head>');
            this.pccategoryData = $(split_data[1]).find('.p-news-category.pc').html();
            this.spcategoryData = $(split_data[1]).find('#p-news-category-select').html();
            this.listData = $(split_data[1]).find('.p-news-list').html();
            this.pagerData = $(split_data[1]).find('.p-news-pagination').html();
            this.append();
        }).fail(function () {
            //error
        });
    }
    append(){

        this.$categoryPC.empty().append(this.pccategoryData);
        this.$categorySP.empty().append(this.spcategoryData);

        TweenMax.to([this.$list,this.$pager],.2, {
            opacity: 0,
            ease: Sine.easeOut,
            onComplete: () => {
                //中身入替え
                this.$list.empty().append(this.listData);
                this.$pager.empty().append(this.pagerData);
                TweenMax.to([this.$list,this.$pager],.3, {
                    opacity: 1,
                    ease: Sine.easeIn,
                    onComplete: () => {
                        this.status.flg = false;
                        this.init(); //dom reset
                        this.scroll.resize(this.scroll);
                    }
                });
            }
        });
    }

}